/* RESPONSIBLE TEAM: team-inbox */
import DefaultPredicateManager from 'embercom/lib/common/predicates/default-predicate-manager';

export default DefaultPredicateManager.extend({});
